module.exports = __webpack_public_path__ + "static/media/bearbarian.3a7d88bb.png";